{
  "nl": {
    "salesWizard": {
      "steps": {
        "contact": "Contactgegevens",
        "license": "Licentie selectie",
        "workshops": "Workshops",
        "school": "School"
      },
      "contactStep": {
        "headline": "Contactformulier voor scholen",
        "description": "Voer uw contactgegevens in, zodat wij u alle benodigde informatie kunnen toesturen. Let vooral op de juiste spelling van uw e-mailadres.",
        "formOfAddress": "Aanhef",
        "formOfAddressFemale": "Mevrouw",
        "formOfAddressMale": "Meneer",
        "firstname": "Voornaam",
        "lastname": "Achternaam",
        "email": "E-mailadres",
        "phone": "Telefoon"
      },
      "entry": {
        "loading": "Het contactformulier wordt voorbereid …",
        "error": "Het contactformulier kon niet worden gestart. Vernieuw de pagina of probeer het later opnieuw."
      },
      "confirmation": {
        "headline": "Hartelijk dank voor uw aanvraag!",
        "offerSingle": "U ontvangt binnenkort een offerte op het volgende e-mailadres:",
        "offerMultiple": "U ontvangt binnenkort verschillende offertes op het volgende e-mailadres:",
        "support": "Mocht u in de tussentijd vragen hebben, neem dan gerust contact op met onze support via",
        "notFound": "Deze aanvraag is niet gevonden. Controleer de link of start een nieuwe aanvraag."
      },
      "saveError": "Opslaan mislukt. Probeer het opnieuw.",
      "choiceStep": {
        "headline": "Selecteer nu een of meerdere licentie-opties",
        "description": "Per licentiepakket ontvangt u een offerte, zodat u deze kunt vergelijken.",
        "numOfEmployees": "Grootte van het team",
        "maxMembersCount": "Aantal benodigde licenties",
        "package": "Kies het juiste licentiepakket",
        "packageLabels": {
          "package_s": "S-licentie",
          "package_m": "M-licentie",
          "package_l": "L-licentie",
          "package_xl": "XL-licentie"
        },
        "upto": "Tot",
        "people": "personen",
        "aboveLimit": {
          "headline": "Individuele offerte voor meer dan 120 personen",
          "description": "Voor een offerte met meer dan 120 licenties adviseren wij u graag persoonlijk. Bel ons op",
          "or": "of",
          "chooseAppointment": "plan een adviesgesprek"
        },
        "bavaria": {
          "headline": "Belangrijke informatie voor Beieren over het media- en AI-budget:",
          "intro": "De volgende licentiepakketten kunnen worden gefinancierd volgens de subsidierichtlijn en in overleg met het Beierse staatsbureau voor scholen:",
          "items": {
            "allInclusive": "All-Inclusive Schoollicentie (100% subsidiabel)",
            "tools": "Tools Schoollicentie (100% subsidiabel)",
            "toTeach": "To Teach Schoollicentie (100% subsidiabel)",
            "combo": "Combi Schoollicentie (slechts gedeeltelijk subsidiabel)"
          },
          "moreInfo": "Meer informatie en een advieslink vindt u hier:"
        },
        "subHeadlineCombined": "Profiteer van onze combinatiepakketten",
        "subHeadlineProduct": "Of selecteer hier afzonderlijke producten",
        "popular": "Populair",
        "year": "Jaar",
        "licenceItemsEmpty": "Er moet minimaal één licentietype worden geselecteerd.",
        "configLoadError": "De licentie-opties konden niet worden geladen."
      },
      "workshopStep": {
        "headline": "Digitale workshops",
        "description": "Aanbeveling: Een jaarlijkse workshop voor het team is ideaal voor een succesvol gebruik van fobizz en een hogere tevredenheid.",
        "itemTypes": {
          "workshop": "Praktijkworkshop",
          "presentation": "Inspiratielezing",
          "consulting": "Individueel advies"
        },
        "durationMinutes": "{duration} minuten",
        "details": "Workshopdetails",
        "configLoadError": "De workshop-opties konden niet worden geladen.",
        "incompleteRequest": "De aanvraag kon niet worden verzonden omdat eerdere stappen onvolledig zijn. Ga terug en vul uw gegevens aan."
      },
      "schoolStep": {
        "headline": "Contactformulier voor scholen",
        "description": "Selecteer hier uw school:",
        "searchHint": "U kunt zoeken op postcode of schoolnaam.",
        "notFoundHint": "Als u uw school niet vindt, vink dan het vakje hieronder aan en vul de gegevens zelf in.",
        "searchLabel": "School",
        "searchPlaceholder": "School zoeken …",
        "searchFieldHint": "Tip: U kunt zoeken op postcode of schoolnaam",
        "noResults": "Geen school gevonden.",
        "initialRequest": "Mijn school staat er niet bij",
        "companyName": "Naam instelling",
        "street": "Straat en huisnummer",
        "zipcode": "Postcode",
        "city": "Plaats",
        "countryCode": "Land",
        "kind": "Onderwijsinstelling",
        "schoolType": "Schooltype",
        "schoolTypeCustom": "Overig schooltype",
        "baseError": "Selecteer een school of vink 'Mijn school staat er niet bij' aan en vul de gegevens zelf in"
      },
      "taxInfo": "Alle prijzen inclusief btw {rate}% (of het geldende btw-tarief)",
      "retry": "Opnieuw proberen",
      "back": "Terug"
    }
  }
}
